import {assert} from 'assert-ts';
import {type CollectionSubType, Concept} from 'types';
import {reverseMap} from 'services/utils/functions/reverseMap';
import type {CollectionTypeDto} from '../types';

const collectionTypeMap: {
  [dto in CollectionTypeDto]: CollectionSubType;
} = {
  SERIES: Concept.series,
  EDUCATIONAL_SERIES: Concept.educationalSeries,
  OTHER_CONNECTION: Concept.otherConnection,
  PUBLISHER_SERIES: Concept.publisherSeries,
};

export const mapCollectionTypeDto = (
  dto: CollectionTypeDto,
): CollectionSubType => collectionTypeMap[dto];

export const mapToCollectionTypeDto = (
  collectionType: CollectionSubType,
): CollectionTypeDto =>
  assert(
    reverseMap(collectionType, collectionTypeMap),
    'mapToCollectionTypeDto',
    {collectionType},
  );
